import {ArrowClockwise, WarningCircle} from '../../../components/PhosphorIcons'

const Error500 = () => (
  <main className='error-page'>
    <div className='error-card'>
      <span className='error-card__icon error-card__icon--danger'>
        <WarningCircle aria-hidden='true' size={30} weight='duotone' />
      </span>
      <span className='error-card__code'>500</span>
      <h1>Не удалось выполнить запрос</h1>
      <p>Сервис временно недоступен. Обновите страницу через несколько секунд.</p>
      <button className='btn btn-primary' onClick={() => window.location.reload()} type='button'>
        <ArrowClockwise aria-hidden='true' size={16} weight='bold' />
        Обновить страницу
      </button>
    </div>
  </main>
)

export {Error500}
